import './App.scss';
import { useState } from 'react';
import { lang } from '../../data/lang';
import { LangContext } from '../../contexts/contexts';
import { CurrentLangContext } from '../../contexts/contexts';
import Nav from '../Fix/Nav/Nav';
import Accueil from '../Accueil/Accueil';
import About from '../About/About';
import Rent from '../Rent/Rent';
import Buy from '../Buy/Buy';
import Lawyer from '../Lawyer/Lawyer';
import Contact from '../Contact/Contact';
import ViewProperty from '../ViewProperty/ViewProperty';
import { Route, Routes } from 'react-router-dom';

function App() {
  const [currentLang, setCurrentLang] = useState("fr");

  // console.log(window, window.innerHeight * 5);
  let lastPositionApp = window.scrollY;

  function showPage() {
    // console.log(window.innerHeight, window.scrollY);
    if (lastPositionApp < window.scrollY) {
      if (window.scrollY > 100 && window.scrollY < (window.innerHeight + 100) && window.location.hash === "") {
        console.log("#about");
        window.location = "#about";     
      }
      if (window.scrollY > (window.innerHeight + 100) && window.scrollY < (window.innerHeight * 2 + 100) && window.location.hash === "#about") {
        console.log("#rent");
        window.location = "#rent";     
      }
      if (window.scrollY > (window.innerHeight * 2 + 100) && window.scrollY < (window.innerHeight *3 + 100) && window.location.hash === "#rent") {
        console.log("#buy");
        window.location = "#buy";     
      }
      if (window.scrollY > (window.innerHeight * 3 + 100) && window.scrollY < (window.innerHeight * 4 + 100) && window.location.hash === "#buy") {
        console.log("#lawyer");
        window.location = "#lawyer";     
      }
      if (window.scrollY > (window.innerHeight * 4 + 100) && window.location.hash === "#lawyer") {
        console.log("#contact");
        window.location = "#contact";     
      }

      lastPositionApp = window.scrollY;
      // console.log("scroll to Top");
    }
    if (lastPositionApp > window.scrollY) {
      if (window.scrollY < (window.innerHeight - 100) && window.location.hash === "#about") {
        console.log("#accueil");
        window.location = "/";     
      }
      if (window.scrollY < (window.innerHeight * 2 - 100) && window.scrollY > (window.innerHeight - 100) && window.location.hash === "#rent") {
        console.log("#about");
        window.location = "#about";     
      }
      if (window.scrollY < (window.innerHeight * 3 - 100) && window.scrollY > (window.innerHeight * 2 - 100) && window.location.hash === "#buy") {
        console.log("#rent");
        window.location = "#rent";     
      }
      if (window.scrollY < (window.innerHeight * 4 - 100) && window.scrollY > (window.innerHeight * 3 - 100) && window.location.hash === "#lawyer") {
        console.log("#buy");
        window.location = "#buy";     
      }
      if (window.scrollY < (window.innerHeight * 5 - 100) && window.scrollY > (window.innerHeight * 4 - 100) && window.location.hash === "#contact") {
        console.log("#lawyer");
        window.location = "#lawyer";     
      }
      
      lastPositionApp = window.scrollY;
      // console.log("scroll to Bottom");
    }
  }

  // window.addEventListener('scroll', showPage);
  // window.addEventListener('resize', showPage);

  return (
    <LangContext.Provider value={lang}>
      <CurrentLangContext.Provider value={[currentLang, setCurrentLang]}>
        <div className="App">
          <Nav />

          <Routes>
            <Route path="/" element={
              <>
                <Accueil />
                <Rent />
                <Buy />
              </>
            } />
            <Route path="/about" element={<About />} />
            <Route path="/rent" element={<Rent />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/lawyer" element={<Lawyer />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          {/* <ViewProperty /> */}
          <a href="https://wa.me/+33768893314" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </CurrentLangContext.Provider>
    </LangContext.Provider>
  );
}

export default App;
